import { createFileRoute } from '@tanstack/react-router'
import { ConsolidatedReportPage } from '@/features/admin/consolidated-report'

export const Route = createFileRoute('/_authenticated/reseller/consolidated-report')({
  component: () => <ConsolidatedReportPage scope='reseller' />,
})
